import { getValidation } from "utils/fieldValidation";

export const airtightnessTypeValidation = getValidation("airTightnessType");
export const ach50Validation = getValidation("airChangeRate50Pa");
export const eqLeakageAreaValidation = getValidation("eqLeakageArea");
export const testPressureValidation = getValidation("blowerTestPressure");
export const siteTerrainValidation = getValidation("buildingSiteTerrain");
export const weatherTerrainValidation = getValidation("weatherStationTerrain");
export const depresStatusValidation = getValidation("depressurizationTestStatus");
export const depresResultValidation = getValidation("depressurizationTestResult");
export const localShieldingFlueValidation = getValidation("localShieldingFlue");
export const localShieldingWallsValidation = getValidation("localShieldingWalls");
export const anemometerValidation = getValidation("weatherStationAnemometer");
export const ceilingLeakageValidation = getValidation("leakageFractionsCeilings");
export const wallsLeakageValidation = getValidation("leakageFractionsWalls");
export const floorsLeakageValidation = getValidation("leakageFractionsFloors");
export const windowTightnessValidation = getValidation("windowAirTightness");
export const commonFloorsValidation = getValidation("commonAreaFloors");
export const commonWallsValidation = getValidation("commonAreaWalls");
export const commonCeilingsValidation = getValidation("commonAreaCeilings");
export const commonTotalValidation = getValidation("commonAreaTotal");

//TODO: Eq leakage area dependencies and calculations
//Old formula for ELA, not used anymore
// export const calcEla = (houseVolume, ach) => {
//     const slope = 0.344224 * houseVolume - 0.0054;
//     const intercept = 0.043961 * houseVolume + 0.026977;

//     return parseFloat((slope * ach + intercept).toFixed(2));
// };

const flowExpMap = {
    0: 0.68, //Average number from initial 300 R2000 homes
    1: 0.725, //loose
    2: 0.698, //average
    3: 0.7125, //Present
    4: 0.7028, //Energy Tight
};

export const calcEla = (houseVolume, ach, testTypeId = 0) => {
    const flowExp = flowExpMap[testTypeId || 0];
    //ACH = Q@∆P / volume => [L/s] or [cfm]
    const airflow = ach * houseVolume * 1000 * (1 / 3600); //[houses/h] * [m3/house] * [1000 L/1m3] * [1h/3600s]
    const flowCoeff = airflow / 50 ** flowExp;
    const ela = 11.57 * Math.sqrt(1.205) * flowCoeff * 10 ** (flowExp - 0.5);
    return parseFloat(ela.toFixed(2));
};

/* TestData */
export const testTypeValidation = getValidation("airTestType");
export const outsideTempValidation = getValidation("airTestOutsideTemp");
export const barometricPressureValidation = getValidation("airTestBarometricPressure");

export let tabList = [
    { name: "Test 1/Equip 1", testKey: "test1Equip1", url: "" },
    { name: "Test 1/Equip 2", testKey: "test1Equip2", url: "&subtab=test2" },
    { name: "Test 2/Equip 1", testKey: "test2Equip1", url: "&subtab=test3" },
    { name: "Test 2/Equip 2", testKey: "test2Equip2", url: "&subtab=test4" },
    { name: "Test 3/Equip 1", testKey: "test3Equip1", url: "&subtab=test5" },
];

export const testTypeTabIndex = {
    0: [tabList[0]],
    1: [tabList[0], tabList[1]],
    2: [tabList[0], tabList[2]],
    3: [tabList[0], tabList[2], tabList[4]],
    4: [tabList[0], tabList[1], tabList[2], tabList[3]],
};

/* TestDataPoints */
export const airTestFanTypeValidation = getValidation("airTestFanType");
export const manometerValidation = getValidation("airTestManometer");
export const initStaticPressureValidation = getValidation("airTestInitialStaticPressure");
export const finalStaticPressureValidation = getValidation("airTestFinalStaticPressure");
export const insideTempValidation = getValidation("airTestInsideTemp");
export const housePressureValidation = getValidation("airTestHousePressure");
export const fanPressureValidation = getValidation("airTestFanPressure");
export const measuredFlowValidation = getValidation("airTestMeasuredFlow");
export const flowRangesValidation = getValidation("airTestFlowRanges");
export const initZone1StaticPressureValidation = getValidation("airTestInitialZonePressure");
export const initZone2StaticPressureValidation = getValidation("airTestInitialZone2Pressure");
export const finalZone1StaticPressureValidation = getValidation("airTestFinalZonePressure");
export const finalZone2StaticPressureValidation = getValidation("airTestFinalZone2Pressure");

export const fanTypeIndex = {
    A: 0,
    B: 1,
    2: 2,
    3: 3,
};

export const getFlowRingFromBld = (fanType, ringIndex) => {
    const flowRingMap = {
        B: {
            0: 4,
            1: 5,
            2: 6,
            3: 7,
        },
        ["3"]: {
            0: 12,
            1: 13,
            2: 14,
            3: 15,
            4: 16,
            5: 17,
        },
    };

    if (Object.keys(flowRingMap).includes(fanType)) {
        return flowRingMap[fanType]?.[ringIndex] || 0;
    }

    return 0;
};
